import React from 'react';

import {MultiValueFilter, Operator} from 'search/SearchConstants';
import StudySearchInput from 'studies/StudySearchInput';

import {BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import {ItemSearchMultiValueFilterForm} from './ItemSearchFilterForm';

interface InStudyFilterFormProps extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onEnter?: () => void;
  onRemove?: () => void;
  operators: Array<Operator>;
}

function InStudyFilterForm(props: InStudyFilterFormProps): JSX.Element {
  return (
    <ItemSearchMultiValueFilterForm
      {...props}
      itemSearchInputClass={StudySearchInput}
      itemSearchInputExtraProps={{shouldAllowMultiple: true}}
    />
  );
}

export default InStudyFilterForm;
